"use strict";

// Export a well-named constant for the browser warning flag on window
export const BROWSER_WARNING_SHOWN_FLAG = '__hasShownBrowserWarning';